export const GET_REQUESTS = "GET_REQUESTS";
export const DOCUMENT_LINK = "DOCUMENT_LINK";
export const GET_ADMIN_REQUESTS = "GET_ADMIN_REQUESTS";
export const CREATE_PHYSICIAN_REQUEST = "CREATE_PHYSICIAN_REQUEST";
export const ADMIN_APPROVAL = "ADMIN_APPROVAL";
export const ADMIN_DENIAL = "ADMIN_DENIAL";
export const GET_ADMIN_REQUESTS_HISTORY = "GET_ADMIN_REQUESTS_HISTORY";
export const SET_PROFILE_HISTORY = "SET_PROFILE_HISTORY";